import { render, staticRenderFns } from "./vueaudit.vue?vue&type=template&id=28b8f58a&scoped=true"
import script from "./vueaudit.vue?vue&type=script&lang=js"
export * from "./vueaudit.vue?vue&type=script&lang=js"
import style0 from "./vueaudit.vue?vue&type=style&index=0&id=28b8f58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8f58a",
  null
  
)

export default component.exports